import { ADD_POC, GET_POC_BY_ID, EDIT_POC } from "./type";

const initialState = {
  pocData: {},
  pocById: {},
};

const baPocReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_POC:
      return {
        ...state,
        pocData: payload,
      };
    case GET_POC_BY_ID:
      return {
        ...state,
        pocById: payload,
      };
    case EDIT_POC:
      return {
        ...state,
        pocData: payload,
      };
    default:
      return { ...state };
  }
};

export default baPocReducer;
